module.exports = __webpack_public_path__ + "static/media/ucc-cork.7ff109d2.png";